/**
 * Show the secondary navigation for a dev devicegroup
 *
 */
import _ from 'underscore';
import Radio from 'backbone.radio';
import NavCollection from '@/collections/nav/nav';
import NavItemView from '@/views/nav/item';
import Handlebars from 'handlebars';
import template from '@/../templates/nav-item-code-editor.hbs';

var selected_code_model;
var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');
// Remember the nav collection we create each time the function is run.
var nav_collection = new NavCollection();
function show_dev_devicegroup_secondary_nav(devicegroup, options) {
    var active = globalCh.request('active_account');
    var primary = globalCh.request('primary_account');
    // Visibility Booleans for items in nav
    // we'll set based on devicegroup and account state
    // WIP: everything is ON right now
    var can_view_code_editor = true;
    var can_view_history = true;
    var can_view_dashboard = true;
    var pre_factoryfixture_devicegroup;
    var devicegroups;

    if (devicegroup.type === 'pre_production_devicegroup') {
        devicegroups = apiCh.request('pre_factoryfixture_devicegroup');
        devicegroups.fetch_all().then( function(){
            pre_factoryfixture_devicegroup = devicegroups.find(
                function(dg){
                    return dg.type === 'pre_factoryfixture_devicegroup'
                            && dg.rel.get('production_target').id === devicegroup.id;
                }
            );
        });
    }

    if (options.code_model) {
        selected_code_model = options.code_model;
    } else {
        selected_code_model = devicegroup.draft;
    }

    // Actions
    function show_code_editor() {
        if (devicegroup.type === 'pre_production_devicegroup') {
            globalCh.request('showCodeEditor',
                                    selected_code_model,
                                    pre_factoryfixture_devicegroup);
            return;
        }
        globalCh.request('showCodeEditor',
                                selected_code_model,
                                devicegroup);
    }
    function show_workspace_devices() {
        if (devicegroup.type === 'pre_factoryfixture_devicegroup') {
            globalCh.request('show_pre_factoryfixture_devices', devicegroup);
        } else if (devicegroup.type === 'pre_production_devicegroup') {
            globalCh.request('show_pre_production_devices', devicegroup);
        } else {
            globalCh.request('show_development_devicegroup_devices', devicegroup);
        }
    }
    function show_devicegroup_code_history() {
        globalCh.request('show_devicegroup_code_history',
                                    devicegroup,
                                    devicegroup.rel.get('product'));
    }
    function show_devicegroup_dashboard() {
        globalCh.request('show_devicegroup_dashboard',
                                    devicegroup,
                                    devicegroup.rel.get('product'));
    }
    options = options || {};
    options = _.extend({
        collection: nav_collection,
        childView: NavItemView.extend({
            templateContext: function () {
                return {
                    draft_or_deployment: ({
                        'draft-editor': 'DRAFT',
                        'deployment-editor': 'SHA'
                    })[this.model.id]
                };
            }
        }),
        childViewOptions: {
            template: Handlebars.compile(template)
        }
    }, options);

    var device_management_title = 'Development Device Group Devices';
    if ( devicegroup.type === 'pre_factoryfixture_devicegroup' ){
        device_management_title = 'Test Factory Fixtures';
    } else if ( devicegroup.type === 'pre_production_devicegroup' ){
        device_management_title = 'Test Production Devices';
    }
    var editor_item = {
        id: selected_code_model.type === 'draft' ? 'draft-editor' : 'deployment-editor',
        title: 'Code',
        icon: 'fa fa-code',
        selected: options.selected === 'code-editor',
        action: show_code_editor,
    };
    var nav_items = _.compact([
    can_view_dashboard && {
        id: 'dashboard',
        title: 'Dashboard',
        icon: 'fa fa-dashboard',
        selected: options.selected == 'dashboard',
        action: show_devicegroup_dashboard
    },
    can_view_code_editor && editor_item,
    can_view_history && {
        id: 'deployment-history',
        title: 'Deployments',
        icon: 'fa fa-history',
        selected: options.selected == 'deployment-history',
        action: show_devicegroup_code_history
    }, active.permits(primary, 'view_development_devices') && {
        id: 'device-management',
        title: device_management_title,
        icon: 'fa ei-icon-device',
        selected: options.selected == 'device-management',
        action: show_workspace_devices
    }]);
    nav_collection.set(nav_items);
    options.category = devicegroup.type;
    if (devicegroup.type === devicegroup.TYPES_MAP.pre_factoryfixture_devicegroup) {
        options.category = 'test-zone';
    }
    globalCh.request('show_secondary_nav', options);
}
export default show_dev_devicegroup_secondary_nav;


